<template>
    <div class="row">
        <input-select-filter v-if="empresas.length > 2  && !this.ehAdmin" class="filter col-12" label="Selecione a empresa ou por grupo de empresas" :options="empresas" v-model="empresaId"/>
        <input-multiple-select v-if="this.ehAdmin"
            :label="$t('Selecione a empresa ou por grupo de empresas')"
            :options="empresas"
            v-model="empresasIDS"
            :limit="40"
            class="filter col-12 mb-3"
        />
        <div class="col-12 col-md" @click="$bvModal.show('bv-modal-valor-investido')">
            <card-dashboard 
                bg-variante="primary" 
                icone="fa-solid fa-file-invoice-dollar" 
                titulo="" 
                :valor="valorTotalInvestido"
                monetario
            >
                <template #titulo>
                    <span>
                        Total<br/>investido
                    </span>
                </template>
            </card-dashboard>
            <b-modal size="xl" id="bv-modal-valor-investido" title="Valor total investido">
                <b-table head-variant="dark" :fields="colunasValorInvestido" :items="dadosValorInvestido"></b-table>
            </b-modal>
        </div>

        <div class="col-12 col-md" @click="$bvModal.show('bv-modal-valor-comprometido')">
            <card-dashboard 
                bg-variante="info" 
                icone="fa-solid fa-filter-circle-dollar fa-3x" 
                titulo="Total comprometido" 
                :valor="valorTotalComprometido"
                monetario
            >
                <template #titulo>
                    <span>
                        Total<br/>comprometido
                    </span>
                </template>
            </card-dashboard>
            <b-modal size="xl" id="bv-modal-valor-comprometido" title="Valor total comprometido">
                <b-table class="table-responsive" head-variant="dark" :fields="colunasPadrao" :items="dadosValorComprometido"></b-table>
            </b-modal>
        </div>

        <div class="col-12 col-md" @click="$bvModal.show('bv-modal-custo-proprio')">
            <card-dashboard 
                bg-variante="success" 
                icone="fa-solid fa-money-check-dollar" 
                titulo="Saldo custos próprios" 
                :valor="saldoCustosProprios"
                monetario
            >
                <template #titulo>
                    <span>
                        Saldo custos<br/>próprios
                    </span>
                </template>
            </card-dashboard>
            <b-modal size="xl" id="bv-modal-custo-proprio" title="Saldo custos próprios">
                <b-table class="table-responsive" head-variant="dark" :fields="colunasPadrao" :items="dadosCustoProprio"></b-table>
            </b-modal>
        </div>
    
        <div class="col-12 col-md" @click="$bvModal.show('bv-modal-projetos-andamento')">
            <card-dashboard 
                bg-variante="warning" 
                icone="fa fa-clipboard-list" 
                titulo="Projetos em andamento" 
                :valor="projetosAndamento"
            >
                <template #titulo>
                    <span>
                        Projetos em<br/>andamento
                    </span>
                </template>
            </card-dashboard>
            <b-modal size="xl" id="bv-modal-projetos-andamento" title="Projetos em andamento">
                <b-table head-variant="dark" :fields="colunasProjetosAndamento" :items="dadosProjetosAndamento"></b-table>
            </b-modal>
        </div>

        <div class="col-12 col-md" @click="$bvModal.show('bv-modal-valor-nonece')">
            <card-dashboard 
                bg-variante="danger" 
                icone="fa-solid fa-hand-holding-dollar" 
                titulo="Investido em NO, NE, CE" 
                :valor="investimentoNONECE"
                monetario
            >
                <template #titulo>
                    <span>
                        Investido em <br/>NO, NE, CE
                    </span>
                </template>
            </card-dashboard>
            <b-modal size="xl" id="bv-modal-valor-nonece" title="Valor investido em NO, NE, CE">
                <b-table head-variant="dark" :fields="colunasNonece" :items="dadosNonece"></b-table>
            </b-modal>
        </div>

        <div class="col-12 col-md-8 mt-4">
            <b-card no-body  style="height: 100%;">
                <b-modal size="xl" id="bv-modal-filtro-movimentacao" hide-footer>
                    <filtro-movimentacao @buscar="buscarMovimentacao" :filtro="filtroMovimentacao" dashboard />
                </b-modal>
                <div class="mt-1 d-flex align-items-center justify-content-between">
                    <h5>
                        Movimentação financeira
                    </h5>
                    <b-button @click="$bvModal.show('bv-modal-filtro-movimentacao')">
                        <i class="fa-solid fa-filter mr-2"></i>
                        Filtro
                    </b-button>
                </div>
                <hr>
                <grafico ref="grafico" :empresas="empresasIDS"/>
            </b-card>
        </div>
        <div class="col-12 col-md-4 mt-4">
            <b-card no-body style="height: 100%;">
                <div class="mt-1 d-flex align-items-center justify-content-between">
                    <h5>
                        Projetos por fase de inovação
                    </h5>
                </div>
                <hr>
                <pizza-proponente ref="pizza"/>
                
            </b-card>
        </div>

        <div class="col-12 mt-4">
            <b-card no-body>
                <b-modal size="xl" id="bv-modal-filtro-projeto" hide-footer>
                    <filtro-projetos @buscar="buscarProjetos" :filtro="filtroProjetos"/>
                </b-modal>
                <div class="mt-1 d-flex align-items-center justify-content-between">
                    <h5>
                        Projetos
                    </h5>
                    <b-button @click="$bvModal.show('bv-modal-filtro-projeto')">
                        <i class="fa-solid fa-filter mr-2"></i>
                        Filtro
                    </b-button>
                </div>
                <hr>
                <tabela ref="projetos"/>
                
            </b-card>
        </div>

        
    </div>
</template>
<script>
import helpers from "@/common/utils/helpers"

import CardDashboard from "@/components/card/CardDashboard";
import Grafico from "./components/GraficoProponente"
import Tabela  from "./components/TabelaPropostasProponente";
import PizzaProponente from "./components/PizzaProponente.vue";
import FiltroProjetos from "./components/Filtro";
import FiltroMovimentacao from "@/views/movimentacao_financeira/accordions/Filtro.vue";

import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import DashboardProponenteService from "@/common/services/dashboards/dashboard_proponente.service.js";
import InputSelectFilter from "../../components/inputs/InputSelectFilter.vue";
import InputMultipleSelect from "../../components/inputs/InputMultipleSelect.vue";
import EmpresasService from "@/common/services/empresas/empresas.service";
export default {
    components:{        
        Grafico,
        CardDashboard,
        FiltroProjetos,
        FiltroMovimentacao,
        Tabela,
        PizzaProponente,
        InputSelectFilter,
        InputMultipleSelect,
        
    },
    data: () => ({
        todasEmpresas: [],
        empresa : [],
        //variaveis cards
        empresasIDS: [],
        empresaId: [],
        valorTotalInvestido: 0,
        valorTotalComprometido : 0,
        saldoCustosProprios : 0,
        projetosAndamento: 0,
        investimentoNONECE : 0,

        grupoNegocio : false,

        filtroMovimentacao : {},
        filtroProjetos : {},

        colunasValorInvestido : [
            {
                key: "label",
                label: "Empresa",
            },
            {
                key: "value",
                label: "Valor investido",
                formatter: (v) => {
                    return helpers.formatarValor(v || 0)
                },
            }
        ],
        colunasNonece : [
            {
                key: "label",
                label: "Empresa",
            },
            {
                key: "value",
                label: "Valor investido",
                formatter: (v) => {
                    return helpers.formatarValor(v || 0)
                },
            }
        ],
        dadosValorInvestido : [],
        colunasProjetosAndamento : [
            {
                key: "codigoProjeto",
                label: "Código do projeto",
            }
        ],

        colunasPadrao : [
            {
                key: "codigoProjeto",
                label: "Código do projeto",
            },
            {
                key: "empresa",
                label: "Empresa",
            },
            { key : "rh.previsto", label : "RH Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) },},
            { key : "rh.realizado", label : "RH Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) },},
            { key : "st.previsto", label : "ST Previsto" , formatter: (v) => { return helpers.formatarValor(v || 0) },},
            { key : "st.realizado", label : "ST Realizado" , formatter: (v) => { return helpers.formatarValor(v || 0) },},
            { key : "mc.previsto", label : "MC Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "mc.realizado", label : "MC Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "mp.previsto", label : "MPE Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "mp.realizado", label : "MPE Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "vd.previsto", label : "VD Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "vd.realizado", label : "VD Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "ou.previsto", label : "OU Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "ou.realizado", label : "OU Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "ac.previsto", label : "AC Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "ac.realizado", label : "AC Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "ci.previsto", label : "CI Previsto", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
            { key : "ci.realizado", label : "CI Realizado", formatter: (v) => { return helpers.formatarValor(v || 0) }, },
        ],
        dadosValorComprometido : [],
        dadosCustoProprio : [],
        dadosProjetosAndamento : [],
        dadosNonece : []
    }),
    methods: {
        getVariant: function(status){
            return helpers.getStatusEtapa(status).variant;
        },

        somarValoresObjetos: function(obj){
            return Object.entries(obj).map(el => {
                    return el[1];
            }).reduce((valorAnterior, el) => {
                return valorAnterior + el;
            }, 0)
        },

        somarValoresObjetosPadrao: function(obj){
            return obj.reduce((valorAnterior, el) => {
                return valorAnterior + (
                    (!el.rh ? 0 : (el.rh.previsto - el.rh.realizado)) +
                    (!el.st ? 0 : (el.st.previsto - el.st.realizado)) +
                    (!el.mc ? 0 : (el.mc.previsto - el.mc.realizado)) +
                    (!el.mp ? 0 : (el.mp.previsto - el.mp.realizado)) +
                    (!el.vd ? 0 : (el.vd.previsto - el.vd.realizado)) +
                    (!el.ou ? 0 : (el.ou.previsto - el.ou.realizado)) +
                    (!el.ac ? 0 : (el.ac.previsto - el.ac.realizado)) +
                    (!el.ci ? 0 : (el.ci.previsto - el.ci.realizado))
                );
            }, 0)
        },

        transformarValoresObjetos : function(obj){
            return Object.entries(obj).map(el => {
                return {label : el[0], value : el[1]};
            })
        },

        buscarCards : function(){
            let grupoNegocio = this.empresa.includes(-1);
            DashboardProponenteService.valorInvestido(grupoNegocio ? null : this.empresa, grupoNegocio).then(res => {
                this.dadosValorInvestido = this.transformarValoresObjetos(res.data.data);
                this.valorTotalInvestido = this.somarValoresObjetos(res.data.data);
            });

            DashboardProponenteService.valorComprometido(grupoNegocio ? null : this.empresa, grupoNegocio).then(res => {
                this.dadosValorComprometido = res.data.data;
                this.valorTotalComprometido = this.somarValoresObjetosPadrao(res.data.data);
            });
            
            DashboardProponenteService.saldoCustosProprios(grupoNegocio ? null : this.empresa, grupoNegocio).then(res => {
                this.dadosCustoProprio = res.data.data;
                this.saldoCustosProprios = this.somarValoresObjetosPadrao(res.data.data);
            });
            
            DashboardProponenteService.projetosAndamento(grupoNegocio ? null : this.empresa, grupoNegocio).then(res => {
                this.dadosProjetosAndamento = res.data.data.map(el => {
                    return {
                        codigoProjeto : el
                    }
                });
                this.projetosAndamento = res.data.data.length;
            });
            
            DashboardProponenteService.valorInvestidoNonece(grupoNegocio ? null : this.empresa, grupoNegocio).then(res => {
                this.dadosNonece = this.transformarValoresObjetos(res.data.data);
                this.investimentoNONECE = this.somarValoresObjetos(res.data.data);
            });

            this.$refs.grafico.buscar(null);
        },

        buscarMovimentacao : function(filtro){
            let grupoNegocio = this.empresa.includes(-1);
            this.$refs.grafico.buscar(grupoNegocio ? null : this.empresa, grupoNegocio, filtro);
            this.filtroMovimentacao = filtro;
            this.$bvModal.hide('bv-modal-filtro-movimentacao');
        },

        buscarProjetos: function (filtro) {
            let grupoNegocio = this.empresa.includes(-1);
            this.$refs.projetos.buscar(grupoNegocio ? null : this.empresa, grupoNegocio, filtro);
            this.$refs.pizza.buscar(grupoNegocio ? null : this.empresa, grupoNegocio, filtro);
            this.filtroProjetos = filtro;
            this.$bvModal.hide('bv-modal-filtro-projeto');
        },
        buscarEmpresas : function(){
            EmpresasService.listar().then(res => {
                this.todasEmpresas = res.data.data.itens.map(el => {return {value: el.id, text: el.nomeFantasia, logo: el.logoDaEmpresa, data: el}});
            });
        }
    },
    mounted(){
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Dashboard"}
        ]);
        this.empresa = this.empresasSelecionada;
        this.empresaId = this.empresasSelecionada;
        this.empresasIDS = [{
            data: this.$store.state.app.selectedCompanyObj,
            logo: this.$store.state.app.selectedCompanyObj.logoCadastrado,
            value: this.empresasSelecionada.toString(),
            text: this.$store.state.app.selectedCompanyObj.nomeFantasia
        }];
    
        this.buscarCards();
        if(this.ehAdmin){
            this.buscarEmpresas();
        }
    },
    watch : {        
        empresa: function () {
            this.buscarCards();
            this.buscarMovimentacao(this.filtroMovimentacao);
            this.buscarProjetos(this.filtroProjetos);
        },
        empresasIDS: function (val) {
            let valuesMappedToId = val?.map(item => item.value)
            this.empresa = valuesMappedToId
        },
        empresaId: function (val) { 
            this.empresa = [val]
        }
    },
    computed:{
        empresasSelecionada : function(){
            if(!this.$store.state.app.selectedCompanyObj)
                return [];
            return [this.$store.state.app.selectedCompanyObj.id];
            
        },
        ehAdmin() {
            return this.$store.getters['app/ehAdmin'];
        },
        empresas : function(){ 
            if(this.ehAdmin){
                return [{ value : -1, text : "Todas empresas"}, ...this.todasEmpresas.filter(el => el.data.tipo =='Proponente')];
            }else{
                return [{ value : -1, text : "Todas empresas"}, ...(this.$store.state.app.userInfo ? (this.$store.state.app.userInfo.pessoa ? 
                    this.$store.state.app.userInfo.pessoa.empresas : []) : []).filter(el=>el.tipo == "Proponente").map(el => {return {value: el.id, text: el.nomeFantasia, data: el}})];
            }
        },
    },
}
</script>
<style>
    .card-img-absolute {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
    }

    #my-chart .charts-css.area {
        height: 200px;
        max-width: 300px;
        margin: 0 auto;
    }

    .filter .form-control{
        background: #FFF;
    }
</style>